import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Event } from '../models/event.model';
import { BankSecurityEvent } from '../models/supplier.model';
import { LocalStorageService } from 'app/shared/services/index.service';
import { OTP_TOKEN } from 'app/shared/services/otp/otp.constants';
import { BANK_TOKEN } from 'app/shared/constants';

@Injectable()
export class EventService extends BaseService {
  constructor(private http: HttpClient,
    private localStorage: LocalStorageService,
    private config: AppSettings) {
    super();
  }

  PostEvent(payload: Event): Observable<any> {
    const url = `${this.config.BaseUrl}Profile/${payload.ReferenceIdentifier}/Event`;
    const model = JSON.stringify({ ReferenceSystem: 'Supplier', ...payload });
    let headers = this.setHeaders();
    if (this.localStorage.retrieve(`${BANK_TOKEN}:${payload.ReferenceIdentifier}`)) {
      headers = headers.set(BANK_TOKEN, this.localStorage.retrieve(`${BANK_TOKEN}:${payload.ReferenceIdentifier}`))
    }
    if (this.localStorage.retrieve(OTP_TOKEN)) {
      headers = headers.set(OTP_TOKEN, this.localStorage.retrieve(OTP_TOKEN));
    }
    return this.http.post(url, model, { headers });
  }

  GetSecurityEvent(payload: string): Observable<BankSecurityEvent> {
    const url = `${this.config.BaseUrl}Profile/Bank/${payload}/RecentBankProfileEvent`
    let headers = this.setHeaders();
    if (localStorage.getItem(`${BANK_TOKEN}:${payload}`)) {
      headers = headers.set(BANK_TOKEN, localStorage.getItem(`${BANK_TOKEN}:${payload}`))
    }
    if (this.localStorage.retrieve(OTP_TOKEN)) {
      headers = headers.set(OTP_TOKEN, this.localStorage.retrieve(OTP_TOKEN));
    }
    return this.http.get<BankSecurityEvent>(url, { headers });
  }
}